import { combineReducers } from "redux";
import {UserProfile,Newsadd} from "./Reducer";
const Reducers = combineReducers({
  UserProfile,Newsadd
  });
  export default Reducers;